export default __webpack_public_path__ + "static/media/div-pattern.e9246502.png";